import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';
import { AppConfig } from './app/Shared/app-config.inject';
import { registerLicense } from '@syncfusion/ej2-base';
import { importProvidersFrom } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { customCurrencyPipe } from './app/Shared/customCurrency.pipe';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './app/Shared/token.interceptor';
import { WordReplacePipe } from './app/Shared/word-replace.pipe';

const requestOrigin = window.location.origin;
registerLicense(environment.syncfusionKey);

function bootstrapApp() {
  const req = new XMLHttpRequest();
  req.addEventListener('load', (res: any) => {
    const appConfig = JSON.parse(res.currentTarget.response);
    environment.syncfusionKey = appConfig.syncfusionKey;
    environment.apiBaseUrl = appConfig.apiBaseUrl;
    environment.production = appConfig.production;

    environment.apiBaseUrl = requestOrigin + "/api";
    console.log("baseURL = ", environment.apiBaseUrl);

    const LOCK_KEY = 'my-app-tab-lock';
    const HEARTBEAT_KEY = 'my-app-tab-heartbeat';
    const ROUTE_KEY = 'my-app-tab-route';
    const WARNING_URL = '/assets/duplicate-tab-warning.html';
    const HEARTBEAT_INTERVAL = 2000;
    const STALE_THRESHOLD = 5000;

    function normalizePath(path: string) {
      return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
    }

    const currentPath = normalizePath(window.location.pathname);

    // Give each tab a unique ID and store in sessionStorage
    const trueTabId = `${Date.now()}-${Math.random()}`;
    if (!window.name || window.name.startsWith('DUPLICATE')) {
      window.name = `TAB-${trueTabId}`;
      sessionStorage.setItem('tab-id', trueTabId);
    }

    const tabId = sessionStorage.getItem('tab-id')!;
    const lockInfoRaw = localStorage.getItem(LOCK_KEY);
    const heartbeatRaw = localStorage.getItem(HEARTBEAT_KEY);
    const lockedRoute = localStorage.getItem(ROUTE_KEY);

    let isDuplicate = false;

    if (lockInfoRaw && heartbeatRaw && lockedRoute) {
      try {
        const lockInfo = JSON.parse(lockInfoRaw);
        const heartbeatTime = parseInt(heartbeatRaw, 10);
        const isStale = Date.now() - heartbeatTime > STALE_THRESHOLD;

        const lockedPath = normalizePath(lockedRoute);
        
        if (lockInfo.tabId !== tabId && !isStale) {
          isDuplicate = true;
        }
      } catch (e) {
        console.error('Tab lock info parse error', e);
      }
    }

    if (isDuplicate) {
      window.location.href = WARNING_URL;
    } else {
      // Store current tab and route
      localStorage.setItem(LOCK_KEY, JSON.stringify({ tabId }));
      localStorage.setItem(HEARTBEAT_KEY, Date.now().toString());
      localStorage.setItem(ROUTE_KEY, currentPath);

      setInterval(() => {
        localStorage.setItem(HEARTBEAT_KEY, Date.now().toString());
        localStorage.setItem(ROUTE_KEY, normalizePath(window.location.pathname));
      }, HEARTBEAT_INTERVAL);

      window.addEventListener('beforeunload', () => {
        const currentLock = JSON.parse(localStorage.getItem(LOCK_KEY) || '{}');
        if (currentLock.tabId === tabId) {
          localStorage.removeItem(LOCK_KEY);
          localStorage.removeItem(HEARTBEAT_KEY);
          localStorage.removeItem(ROUTE_KEY);
        }
      });
    }

    bootstrapApplication(AppComponent, {
      providers: [
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        },
        CurrencyPipe,
        customCurrencyPipe,
        DatePipe,
        WordReplacePipe,
        provideRouter(appRoutes),
        provideHttpClient(), // 🔧 Required for any HTTP services
        {
          provide: AppConfig,
          useValue: { ...appConfig }
        },
        importProvidersFrom(
          ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
          })
        )
      ]
    }).catch(err => console.error(err));
  });

  req.open('GET', '/assets/config/config.json');
  req.send(null);
}

bootstrapApp();

